
import React from "react";
import { NetworkIcon } from "../../../icons/NetworkIcon";

const EmptyNetworkState: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center h-[400px] w-full bg-gray-50 border border-dashed border-gray-200 rounded-lg p-8">
      <div className="mb-6">
        <NetworkIcon size={48} className="w-16 h-16 text-gray-400" />
      </div>
      <h3 className="text-xl font-medium text-gray-700 mb-2">No Content to Visualize</h3>
      <p className="text-gray-500 text-center max-w-md">
        Add some content items to see them displayed as an interactive network graph.
      </p>
    </div>
  );
};

export default EmptyNetworkState;
